import { IMappingTextPack, olMap, IMap } from "@esdm/map";
import { HbsmrUser } from "./HbsmrUser";
import { IVectorLayerGroupConfig } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { SuffolkRecordType, SuffolkRecordSubType } from "./SuffolkRecordTypes";

export class MapBase {

    constructor(    
        protected mappingTextPack: IMappingTextPack,
        protected user: HbsmrUser) {        
    }

    protected isAuthenticated = (): boolean => {
        return this.user !== null;
    }

    protected filterMapLayers = (layerGroupConfig: Array<IVectorLayerGroupConfig> ): Array<IVectorLayerGroupConfig> => {
        if (!this.isAuthenticated()) {
            //remove layers that require authentication
            return layerGroupConfig.filter(function (value, index, arr) {
                let authlayers = (value.subType === SuffolkRecordSubType.Shine || value.type === SuffolkRecordType.Consultation);
                return !authlayers;
            });
        } else {
            return layerGroupConfig;
        }
    }    

}